import type { ProjectSnapshot } from '@/model/sourceState/sourcestate.generated';

import { unwrapEnvelopeOr } from '@/model/client';
import {
  sourceStateApi,
  useGetApiProjectsByProjectIdSourceStatesQuery,
} from '@/model/sourceState/api.generated';
import {
  isSourceSyncing,
  pollingIntervalFor,
} from '@/viewmodel/features/sourceState/mappers/polling';
import { skipToken } from '@reduxjs/toolkit/query/react';

export function useProjectSourceStates(
  projectId: string | undefined,
  liveUpdates: boolean,
  awaitingRun = false,
): { snapshot: ProjectSnapshot | undefined } {
  const arg = projectId ? { projectId } : skipToken;
  const { data: cached } =
    sourceStateApi.endpoints.getApiProjectsByProjectIdSourceStates.useQueryState(arg);
  const sources = unwrapEnvelopeOr<ProjectSnapshot | undefined>(cached, undefined)?.sources ?? [];
  const pollingInterval = pollingIntervalFor(
    liveUpdates,
    sources.some(isSourceSyncing),
    awaitingRun,
  );
  const query = useGetApiProjectsByProjectIdSourceStatesQuery(arg, {
    pollingInterval,
    skipPollingIfUnfocused: true,
  });

  return { snapshot: unwrapEnvelopeOr<ProjectSnapshot | undefined>(query.data, undefined) };
}
